<template>
	<div id="n">
		<canvas ref="c" v-for="i in 5" :key="i"/>
	</div>
</template>

<script>
import {TweenLite} from 'gsap/TweenLite'
import {TimelineLite} from 'gsap/TimelineLite'

export default {
	name: 'BackgroundNoise',
	components: {},
	data() {
		return {
			a: 1,
		}
	},
	props: {
		// state
		// href: String,
		// iconFileName: {
		// 	type: String,
		// 	required: true,
		// },
		// text
		// text: {
		// 	type: String,
		// 	default: 'more',
		// },
	},
	computed: {
		// iconClass() {
		// 	return (this.isAll) ? 'is-all' : ''
		// },
		// text() {
		// 	return (this.isAll) ? this.textNonActive : this.textActive
		// },
	},
	methods: {
		drawNoise() {
			if (this.$refs['c'] && (window.innerWidth > this.$refs['c'][0].width || window.innerHeight > this.$refs['c'][0].height)) {
				this.$refs['c'].forEach(canvas => {
					const ctx = canvas.getContext('2d'),
						dS = 100, wWidth = window.innerWidth + dS,
						wHeight = window.innerHeight + dS

					// Set canvas size
					canvas.width = wWidth
					canvas.height = wHeight

					let noiseData = []

					// Create Noise Data
					const idata = ctx.createImageData(wWidth, wHeight)
					const pixels = new Uint8ClampedArray(idata.data.buffer)

					for (let i = 0; i < pixels.length; i++) {
						if (Math.random() < .2) {
							pixels[i] = 50
						}
					}

					noiseData.push(idata)

					// Draw noise on canvas
					ctx.putImageData(noiseData[0], 0, 0)
				})
			}
		},
		loopNoise() {
			// const self = this
			//
			// requestAnimationFrame(() => {
			// 	setInterval(function () {
			// 		if (self.a === self.$refs['c'].length) {
			// 			self.a = 1
			// 		} else {
			// 			self.a++
			// 		}
			// 		TweenLite.set(self.$el.querySelectorAll('canvas'), {
			// 			autoAlpha: 0
			// 		})
			// 		TweenLite.set(self.$refs['c'][self.a - 1], {
			// 			autoAlpha: 1
			// 		})
			// 	}, 1000/24)
			// })
			const st = {s: 0},
				cl = this.$refs['c'].length,
				lTl = new TimelineLite({
					onComplete: () => {
						lTl.restart()
					}
				})

			lTl.to(st, (1/10 * cl), {
				s: cl - 1,
				roundProps: "s",
				onUpdate: () => {
					TweenLite.set(this.$el.querySelectorAll('canvas'), {
						opacity: 0,
					})
					TweenLite.set(this.$refs['c'][st.s], {
						opacity: 1,
					})
				},
			})
		},
	},
	mounted() {
		// draw noise
		this.drawNoise()

		// loop noise
		this.loopNoise()

		// redraw on resize
		window.addEventListener('resize', this.drawNoise)
	},
	watch: {},
}
</script>

<style lang="scss">
#n {
	@extend %sizing-fixed-fw-fh;
	background-color: var(--dark);
	canvas {
		position: absolute;
		top: 0;
		left: 0;
		will-change: opacity;
	}
}
</style>
